import { Directive, Input, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
@Directive({
  selector: 'input[showError], textarea[showError], mat-select[showError]',
})
export class ShowErrorDirective {
  @Input() formControlName: string;
  constructor(@Optional() @Self() public ngControl: NgControl) {}
}
